import { createFileRoute } from '@tanstack/react-router';

import { AssembliesPage } from '@/areas/settings/bom-components/Settings/AssembliesPage/AssembliesPage';
import { canViewDesignSettings } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/settings/_menu/organization/assembly-settings')({
    staticData: {
        access: { permissions: canViewDesignSettings },
        chrome: 'none',
    } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <AssembliesPage />;
}
